import { DatabaseStreamState } from '../database-stream-state';

const streamState = DatabaseStreamState.getInstance();

export const handleStreamCompleted = () => {
  streamState.completeStreaming();
};

export const handleStreamErrored = () => {
  streamState.completeStreaming();
};

export const handleStreamAborted = () => {
  streamState.completeStreaming();
};
